export const InputTypes = Object.freeze({
  TEXT: "text",
  NUMBER: "number",
  TELEPHONE_NUMBER: "telephoneNumber",
  SELECT: "select",
  MULTIPLE_SELECT: "multipleSelect",
  DATE: "dateTimePicker",
  RICH_TEXT_AREA: "richTextArea",
  TEXT_AREA: "textArea",
  EMAIL: "email",
  PASSWORD: "password",
  DELETE: "delete",
  SAVE: "save",
  PREVIEW: "preview",
  COMPOSED: "composed",
  ARRAY: "array",
  REDIRECT: "redirect",
  RECIPE_NAME: "recipeName",
  SELECT_WITH_PLACEHOLDER: "selectWithPlaceholder",
  DRAG_AND_DROP_INGS: "dragAndDropIngredients",
  DRAG_AND_DROP_PREP: "dragAndDropPreparation",
  MONETARY_NUMBER: "monetaryNumber",
  POPUP_ARRAY: "popupArray",
  VIDEOCALL: "videocall",
  URL: "url",
});
